import Api from '../services/Api'
import { DELETE_USER_ERROR, LOGIN_ERROR, REGISTER_ERROR, UPDATE_USER, REMOVE_ALL_ERRORS } from './index'

const apiService = new Api()

const extractError = (err) => {
  if (!err) return 'Unknown error'
  const data = err.response && err.response.data
  if (!data) return err.message || 'Network error'
  if (data.error && data.error.message) return data.error.message
  if (data.message) return data.message
  if (Array.isArray(data) && data[0] && data[0].messages && data[0].messages[0]) {
    return data[0].messages[0].message
  }
  return JSON.stringify(data)
}

export const removeErrors = () => ({
  type: REMOVE_ALL_ERRORS,
  payload: null
})

export const checkMe = () => dispatch => {
  if (localStorage.getItem('jwt')) {
    apiService.checkMe()
      .then(res => dispatch({
        type: UPDATE_USER,
        payload: res
      }))
      .catch(err => {
        localStorage.removeItem('jwt')
        return dispatch({
          type: UPDATE_USER,
          payload: null
        })
      })
  } else {
    return dispatch({
      type: UPDATE_USER,
      payload: null
    })
  }
}

export const deleteUser = (id, places) => dispatch => {
  apiService.deleteUser(id, places)
    .then(res => dispatch({
      type: UPDATE_USER,
      payload: null
    }))
    .catch(err => dispatch({
      type: DELETE_USER_ERROR,
      payload: 'Une erreur s\'est produite!'
    }))
}

export const login = (username, password) => dispatch => {
  apiService.login(username, password)
    .then(res => dispatch({
      type: UPDATE_USER,
      payload: res.user
    }))
    .catch(err => dispatch({
      type: LOGIN_ERROR,
      payload: extractError(err)
    }))
}

export const loginWithFacebook = (search) => dispatch => {
  apiService.loginWithFacebook(search)
    .then(res => dispatch({
      type: UPDATE_USER,
      payload: res.user
    }))
    .catch(err => dispatch({
      type: LOGIN_ERROR,
      payload: extractError(err)
    }))
}

export const logout = () => dispatch => {
  localStorage.removeItem('jwt')
  return dispatch({
    type: UPDATE_USER,
    payload: null
  })
}

export const register = (username, email, password) => dispatch => {
  apiService.register(username, email, password)
    .then(res => dispatch({
      type: UPDATE_USER,
      payload: res.user
    }))
    .catch(err => dispatch({
      type: REGISTER_ERROR,
      payload: extractError(err)
    }))
}
